<template>
  <div>   
    <ScoreStartArmy2 :row="row.start"  :list="row.list" :start="row.start.subject" v-if="show_type == 2 && row.start.subject!=''"></ScoreStartArmy2>
    <ScoreStartArmy3 :row="row.start"  :list="row.list" :start="row.start.subject" v-if="show_type == 4 && row.start.subject!=''"></ScoreStartArmy3>
    <ScoreStartRank2 :row="row.start" :list="row.list" :start="row.start.subject" v-if="show_type == 3&& row.start.subject!=''"></ScoreStartRank2>


  </div>
</template>

<script>
import {Toast} from "vant";
import ScoreStartList2 from "@/components/score/ScoreStartList2.vue";
import ScoreStartArmy2 from "@/components/score/ScoreStartArmy2.vue";
import ScoreStartArmy3 from "@/components/score/ScoreStartArmy3.vue";
import ScoreStartRank2 from "@/components/score/ScoreStartRank2.vue";
import ScoreStartSubjectRank2 from "@/components/score/ScoreStartSubjectRank2.vue";
export default {
  name: "ScoreShow2",
  data: function () {
    return {
      show_type:0,
      row: {
        start: {
          current_show_type: 0,
        },
        list: [],
        rank_list: []
      }
    }
  },
  components: {
    ScoreStartList2, ScoreStartArmy2,ScoreStartArmy3, ScoreStartSubjectRank2,ScoreStartRank2
  },
  filters: {},
  mounted() {
    let that = this;
    document.title="数据展示"
    that.fetch()
    this.show_type = that.$route.query.show_type
    // 换成轮询
    that.timer = setInterval(function () {
      that.fetch()
    }, 2000)
  },
  destroyed() {
    // 销毁监听
    // this.socket.close()
    clearInterval(this.timer)
  },
  methods: {
    fetch() {
      let that = this;
      let url = '';
      if(this.show_type==2||this.show_type==4){
        url = '/api/dscore/scoreShowInfo'
      }else{
        url = '/api/dscore/scoreShowResult'
      }
      that.$api.post(url, {
        saiqu: that.$route.query.saiqu,
        start_id: that.$route.query.start_id,
      }, (res) => {
        that.row = res.data;
      }, (res) => {
        if (res.code == 401 || res.code == 402) {
          if (window.isApp()) {
            rbLink({
              name: 'login', 'query': {}
            }, 'replace');
            return false;
          }
          that.loginShow = true
        } else {
          Toast(res.msg)
        }
      })
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ScoreShow2.vue?5975a602